import { __awaiter } from "tslib";
import React from 'react';
import ReactDOM from 'react-dom';
import log from '../../utils/log';
import AffiliateUnitModule from 'pathfinder/modules/AffiliateUnitModule/AffiliateUnitModule';
import { fetchTargetingFromAffiliateService, getAvailableUnits, } from 'pathfinder/api/affiliates';
import { findInfoBox, renderUnitMarkup, } from 'pathfinder/modules/AffiliateUnitModule/helper/affiliateUnitPlacementHelper';
import { retrieveAffiliateUnitMetadata, } from 'pathfinder/modules/AffiliateUnitModule/helper/affiliateUnitPageMetadataHelper';
import { isLocalHost } from 'utils/env';
import deepmerge from 'deepmerge';
import { buildModuleProps } from 'pathfinder/rules-engine/moduleProps';
export const getAffiliateUnitModuleMethods = (moduleConfig) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c;
    const isForced = (_a = moduleConfig === null || moduleConfig === void 0 ? void 0 : moduleConfig.internalState) === null || _a === void 0 ? void 0 : _a.forced;
    const props = buildModuleProps(moduleConfig);
    /* Init function replicated logic */
    // Logic to attach the AffiliateUnit into a specific HTML element
    // Check if .portable-infobox classname is present, and create a reference to attaching it there
    // else, check if .infobox class is present on the page and create a reference to attaching it there
    // Check if the unit can be displayed, if it can't then return from the function
    // If it can be, then exit logic to addUnitToPage similar to the UCP
    const moduleProps = buildModuleProps(moduleConfig, {});
    const infoBox = findInfoBox();
    if (!infoBox && !isLocalHost()) {
        log.debug('AffiliateUnit: Could not find any infobox element on the page. Aborting affiliate unit render.');
        return false;
    }
    let affiliateUnit;
    const affiliateUnitPageMetadata = yield retrieveAffiliateUnitMetadata();
    let affiliateResponse;
    let availableAffiliateUnits;
    if ((_b = moduleProps.config) === null || _b === void 0 ? void 0 : _b.forcedUnit) {
        affiliateUnit = moduleProps.config.forcedUnit;
    }
    else {
        // START - Logic for display AffiliateUnit component
        affiliateResponse = yield fetchTargetingFromAffiliateService(affiliateUnitPageMetadata);
        // In case the response from the API returned no records, then don't bother doing a further render
        if (affiliateResponse.length === 0) {
            return false;
        }
        availableAffiliateUnits = getAvailableUnits(affiliateResponse, isForced);
        // Leave as any for now, for debugging purposes
        // let affiliateUnit: AffiliateUnit;
        if (availableAffiliateUnits.length > 0) {
            affiliateUnit = availableAffiliateUnits[0];
            log.debug('AffiliateUnit: Found an available unit to display from the list', affiliateUnit, availableAffiliateUnits);
        }
        else {
            // In case no affiliate units were returned, then don't render the AffiliateUnitModule component, and return null.
            log.debug('AffiliateUnit: No recommendations.');
            return false;
        }
    }
    // Equivalent of handleVariants case from bingeBit except that a majority of the DOM needs to be traversed in order to find the best insertion point.
    // A majority of that functionality is present in the AffiliateUnitModule/helper/affiliateUnitPlacementHelper file
    const affiliatePropsWithPlacement = renderUnitMarkup(infoBox, affiliateUnit, affiliateUnitPageMetadata);
    log.debug('AffiliateUnit: Placement', { affiliateUnit, infoBox });
    // If for some reason the affiliateProps and placement don't get generated,
    // then return null so that React doesn't throw an error when destructuring a null object
    if (!affiliatePropsWithPlacement) {
        return false;
    }
    const { config } = affiliatePropsWithPlacement;
    const flattenedConfig = deepmerge(config, (_c = moduleConfig === null || moduleConfig === void 0 ? void 0 : moduleConfig.config) !== null && _c !== void 0 ? _c : {});
    const render = () => {
        const reactRoot = document.createElement('div');
        ReactDOM.render(React.createElement(AffiliateUnitModule, {
            config: flattenedConfig,
            track: props.track,
            isForced,
        }), reactRoot);
        // insert the html
        if (isLocalHost()) {
            document.querySelector('body').appendChild(reactRoot);
        }
        else {
            affiliatePropsWithPlacement.insertionPoint.before(reactRoot);
            log.debug('AffiliateUnit/CustomerInsert: affiliate insertionPoint: ', affiliatePropsWithPlacement.insertionPoint);
        }
    };
    return {
        render,
    };
});
